// extracted by mini-css-extract-plugin
module.exports = {"container":"_36665a6","frame":"_449f5cb"};